import { useAddCartRowMutation, useAddWheelPackageMutation } from "@/api/cart"
import { CartAddWheelPackageModel, CartRowEditModel } from "@/types/api"
import { useRouter } from "next/router"
import useAnalyticsManager from "./useAnalyticsManager"

type AddToCartItem = {
  articleId: number
  quantity: number
  kType?: number
  licensePlate?: string
  // used to send to analytics
  price: number
  // used to send to analytics
  articleText: string
}

type AddWheelPackageToCartItem = {
  articleIds: number[]
  quantity: number
  kTypeId: number
  licensePlate?: string
  packageId?: number
  rimFilterQuery?: string
  tyreFilterQuery?: string
}


const useAddToCart = () => {
  const [addArticleToCart] = useAddCartRowMutation()
  const [addWheelPackage] = useAddWheelPackageMutation()
  const router = useRouter()
  const analyticsManager = useAnalyticsManager()

  const addToCart = async (payload: AddToCartItem) => {
    try {
      const model = { articleId: payload.articleId, quantity: payload.quantity, kType: payload.kType, licensePlate: payload.licensePlate } as CartRowEditModel
      await addArticleToCart(model)
      router.push("/cart")
      analyticsManager.addToCart(payload.articleId, payload.articleText, payload.quantity, payload.price)
    } catch (error) {
      console.error('Failed to add item to cart:', error)
    }
  }

  const addPackageToCart = async (payload: AddWheelPackageToCartItem) => {
    try {
      const model: CartAddWheelPackageModel = {
        articles: [
          { articleId: payload.articleIds[0], savedFilterQuery: payload.rimFilterQuery || '' },
          { articleId: payload.articleIds[1], savedFilterQuery: payload.tyreFilterQuery || '' }
        ],
        quantity: payload.quantity,
        kType: payload.kTypeId,
        licensePlate: payload.licensePlate || '',
        packageId: payload.packageId
      }
      await addWheelPackage(model)
      router.push("/cart")
      analyticsManager.addToCart(payload.articleIds[0], "", payload.quantity, 0)
      analyticsManager.addToCart(payload.articleIds[1], "", payload.quantity, 0)
    } catch (error) {
      console.error('Failed to add package to cart:', error)
    }
  }

  return { addToCart, addPackageToCart }
}

export default useAddToCart